<form [formGroup]="formName">
    <mat-form-field class="w-100">
        <mat-label>{{ field.label }}</mat-label>
        @if (field.name) {
            <mat-select
                #dynamicSelect
                [formControlName]="field.name"
                [matTooltip]="field.tooltipMessage || ''"
                [appDisableControl]="field.isDisabled || false"
            >
                @for (option of options; let optionIndex = $index; track optionIndex) {
                    <mat-option [value]="option?.value"> {{ option.displayValue }} </mat-option>
                }
            </mat-select>
        }

        <mat-error>
            <app-dynamic-error [field]="field" />
        </mat-error>
        @if (fetchingData) {
            <mat-icon matIconSuffix>
                <mat-spinner diameter="24" />
            </mat-icon>
        }
    </mat-form-field>
</form>
